import React from "react";
import "./style.css";
import team4 from "./team4.jpg";
import team5 from "./team5.jpg";

const AudiologyTeamSection = () => {
  return (
    <section className="team-section py-5" style={{ marginTop: "40px" }}>

      {/* Background + icons */}
      <div className="bg-plus plus-left">+</div>
      <div className="bg-plus plus-right">+</div>

      <div className="container text-center">
        <div className="pq-section pq-style-1 text-center">
          <h2 className="text-center mb-3 pq-section-title">
            MEET OUR EXPERT TEAM
          </h2>
          <p className="sub-title">
            Experienced • Compassionate • Dedicated to Your Care
          </p>
        </div>

        <div className="row mt-3 g-4">

          <div className="col-md-1"></div>

          {/* CARD 1 */}
          <div className="col-md-5">
            <div className="card-box">
              <div className="img-box">
			   <img src={team4} alt="Harshvardhan Singh" />
              </div>

              <h5>Harshvardhan Singh</h5>
              <p className="degree">BASLP</p>

              <span className="role">Senior Audiologist</span>

              <ul>
                <li>
                  <span className="icon">
                    <i className="fa-solid fa-award"></i>
                  </span>
                  12+ Years of Experience
                </li>
              </ul>

              <button>VIEW PROFILE</button>
            </div>
          </div>

          {/* CARD 2 */}
          <div className="col-md-5">
            <div className="card-box">
              <div className="img-box">
			   <img src={team5} alt="Nikita Chatterjee" />
              </div>

              <h5>Nikita Chatterjee</h5>
              <p className="degree">BASLP, MASLP, W.B.U.H.S</p>

              <span className="role">
                Sr. Audiologist and Speech Language Pathologist
              </span>

              <ul>
                <li>
                  <span className="icon">
                    <i className="fa-solid fa-award"></i>
                  </span>
                  6+ Years of Experience
                </li>
              </ul>

              <button>VIEW PROFILE</button>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AudiologyTeamSection;